import * as at from '../actionTypes'
import { createAction } from '@reduxjs/toolkit'
import { Employee } from '@/schemaTypes'

export const logoutCurrentUser = createAction<undefined>(at.USER_LOGOUT)

export const setCurrentUser = createAction<Employee>(at.USER_SET_CURRENT)
